// extracted by mini-css-extract-plugin
export default {"container":"src-components-Table-next-components-SbDataTableCell__container--IugT9"};